export enum NpsIconEnum {
  STAR = "star",
  HEART = "heart",
  SMILE = "smile",
  NUMERIC = "numeric",
}
